angular.module('impactx.orderconfiguration').directive('ixFtpOrderExportConfiguration', function () {
    return {
        scope: {
            data: '=',
            form: "=",
            trns: "=",
            readOnly: '='
        },
        restrict: 'E',
        templateUrl: 'modules/orderconfiguration/templates/ftporderexportconfiguration.html'
    };
});